import { useCallback, useEffect, useRef, useState } from "react";

export function useAdminResource(loader, fallbackData) {
  const [data, setData] = useState(fallbackData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const fallbackRef = useRef(fallbackData);
  const requestIdRef = useRef(0);

  useEffect(() => {
    fallbackRef.current = fallbackData;
  }, [fallbackData]);

  const reload = useCallback(async () => {
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;

    setLoading(true);
    setError("");

    try {
      const nextData = await loader();
      if (requestIdRef.current !== requestId) return;

      setData(nextData);
    } catch (err) {
      if (requestIdRef.current !== requestId) return;

      setError(err.message);
      setData(fallbackRef.current);
    } finally {
      if (requestIdRef.current !== requestId) return;

      setLoading(false);
    }
  }, [loader]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, error, loading, reload, setData };
}
